import React, { useState } from 'react';
import { Mail, Trash2, Sparkles, Loader2 } from 'lucide-react';
import { authAxios, apiErrorMessage } from '@/lib/api';

const FALLBACK_WHATSAPP = '919284548218';

export default function InquiryActions({ inquiry, onAiReply, onDelete }) {
  const [generating, setGenerating] = useState(false);

  const requestAiReply = async () => {
    setGenerating(true);
    onAiReply(null);
    try {
      const { data } = await authAxios.post('/api/ai/suggest-reply', {
        inquiry_name: inquiry.name,
        company: inquiry.company,
        country: inquiry.country,
        product_interest: inquiry.product_interest,
        quantity: inquiry.quantity || '',
        message: inquiry.message || '',
        stage: inquiry.stage || 'new',
      });
      onAiReply(data);
    } catch (e) {
      alert('AI suggestion failed: ' + apiErrorMessage(e));
    } finally {
      setGenerating(false);
    }
  };

  const mailSubject = `Re: Inquiry about ${inquiry.product_interest} - ASJK Laxmi Global`;
  const waNumber = inquiry.phone?.replace(/\D/g, '') || FALLBACK_WHATSAPP;

  return (
    <div className="flex flex-wrap gap-2 mb-5">
      <a href={`mailto:${inquiry.email}?subject=${mailSubject}`} className="inline-flex items-center gap-1.5 bg-saffron text-white font-sans font-semibold text-xs px-4 py-2 rounded-md hover:bg-saffron-dark transition-colors" data-testid="reply-email"><Mail size={12} /> Reply Email</a>
      <a href={`https://wa.me/${waNumber}`} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 bg-[#25D366] text-white font-sans font-semibold text-xs px-4 py-2 rounded-md" data-testid="reply-whatsapp">WhatsApp</a>
      <button
        onClick={requestAiReply}
        disabled={generating}
        className="inline-flex items-center gap-1.5 bg-gradient-to-r from-amber-500 to-orange-500 text-white font-sans font-semibold text-xs px-4 py-2 rounded-md hover:from-amber-600 hover:to-orange-600 transition-all disabled:opacity-50 shadow-sm"
        data-testid="ai-suggest-reply"
      >
        {generating ? <><Loader2 size={12} className="animate-spin" /> Generating...</> : <><Sparkles size={12} /> AI Suggest Reply</>}
      </button>
      <button onClick={onDelete} className="inline-flex items-center gap-1.5 bg-red-500 text-white font-sans font-semibold text-xs px-4 py-2 rounded-md hover:bg-red-600 transition-colors" data-testid="delete-inquiry"><Trash2 size={12} /> Delete</button>
    </div>
  );
}
